import {Injectable} from "@angular/core";
import {
  Rule
} from "@ispm-client/modules/query-builder/models/query-builder-config";
import {QueryService} from "./query-service";


@Injectable()
export abstract class FactorBaseService {
  static readonly NOT = "not ";
  static readonly EQUALS = "=";
  static readonly NOTEQUALS = "!=";
  static readonly _TYPE = "type";
  static readonly SPACE = " ";

  protected parameterRulesMap: { [field: string]: Rule; } = {};

  protected keyExists(key: string): boolean {
    let keys: string[] = Object.keys(this.parameterRulesMap);
    return (keys.indexOf(key) >= 0);
  }

  protected pushWithOperator(rule: Rule, displayValue:  string, results: string[], prefix: string = '') {
    displayValue = prefix + this.prependOperator(rule, displayValue);
    results.push(displayValue);
  }

  private prependOperator(rule: Rule, displayValue: string): string {
    let operator = rule.operator;
    if (operator !== FactorBaseService.EQUALS) {
      if (operator === FactorBaseService.NOTEQUALS) {
        displayValue = FactorBaseService.NOT + displayValue;
      } else {
        displayValue = operator + displayValue;
      }
    }
    return displayValue;
  }

  // protected pushValueDisplay(field: string, results: string[]) {
  //   let rule = this.parameterRulesMap[field];
  //   if (rule) {
  //     let displayValue: string = rule.value.display;
  //     this.pushWithOperator(rule, displayValue, results);
  //   }
  // }
  //
  // protected pushValue(field: string, results: string[]) {
  //   let rule = this.parameterRulesMap[field];
  //   if (rule) {
  //     let displayValue: string = rule.value;
  //     this.pushWithOperator(rule, displayValue, results);
  //   }
  // }

}
